export const sanitizeUfoName = name => {
  return name.replace(/_/g, '-');
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSegmentLabel(obj) {
  return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}